"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmojiPickerSearchBar = EmojiPickerSearchBar;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function EmojiPickerSearchBar(_ref) {
  var children = _ref.children,
    i18n = _ref.i18n,
    searchValue = _ref.searchValue,
    setSearch = _ref.setSearch;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex items-center px-2",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "relative flex grow items-center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        "aria-label": "Search",
        autoComplete: "off",
        className: "block w-full appearance-none rounded-full border-0 bg-accent px-10 py-2 text-sm outline-none placeholder:text-muted-foreground focus-visible:outline-none",
        onChange: function onChange(event) {
          return setSearch(event.target.value);
        },
        placeholder: i18n.search,
        type: "text",
        value: searchValue
      }), children]
    })
  });
}